import React from "react";
import { SearchInput } from "../../../../../../common/components";
import styles from "./FeatureSearch.module.css";
import { translate } from "../../../../../../common/providers";

const FeatureSearch = ({ name, onChangeSearchValue }) => {
	const handleChangeSearchValueHandler = (e) => {
		onChangeSearchValue(e.target.value);
	};
	const handleClearSearchValue = () => {
		onChangeSearchValue("");
	};
	return (
		<div className={styles.searchContainer}>
			<SearchInput
				className={styles.searchContainer__textfield}
				label={translate("common:categories.textfield.label")}
				value={name}
				onChange={handleChangeSearchValueHandler}
				onClearSearch={handleClearSearchValue}
			/>
		</div>
	);
};

export default FeatureSearch;
